var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upselling" }, [
    _vm.custom
      ? _c(
          "div",
          { staticClass: "upselling-custom shadow-box" },
          [
            _vm._t("default"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "add-to-basket",
                attrs: { disabled: _vm.isLoading },
                on: {
                  click: function ($event) {
                    return _vm.addToBasket(_vm.variationId)
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-cart-plus" })]
            ),
          ],
          2
        )
      : _c("div", [
          _vm.upsellingItems.length
            ? _c("div", { staticClass: "upselling-items" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "upselling-swiper" }, [
                  _c(
                    "div",
                    { ref: "upselling-swiper", staticClass: "swiper" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-wrapper",
                          attrs: { role: "list" },
                        },
                        _vm._l(
                          _vm.upsellingItems,
                          function (upsellingItem, index) {
                            return _c(
                              "div",
                              {
                                key: index + "-upselling",
                                staticClass: "swiper-slide",
                                attrs: { role: "listitem" },
                              },
                              [
                                _c("div", { staticClass: "upselling-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "upselling-item-left" },
                                    [
                                      upsellingItem.data.images.variation[0]
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "item-name",
                                              attrs: {
                                                href: _vm._f("itemURL")(
                                                  upsellingItem.data
                                                ),
                                              },
                                            },
                                            [
                                              upsellingItem.data.images
                                                .variation[0].urlMiddle
                                                ? _c("lazy-img", {
                                                    attrs: {
                                                      "image-url":
                                                        upsellingItem.data
                                                          .images.variation[0]
                                                          .urlMiddle,
                                                      alt: _vm._f("itemName")(
                                                        upsellingItem.data
                                                      ),
                                                      height: "65",
                                                      width: "65",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "upselling-item-left-content",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "item-name",
                                              attrs: {
                                                href: _vm._f("itemURL")(
                                                  upsellingItem.data
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("itemName")(
                                                    upsellingItem.data
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "upselling-item-right" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "item-total-price" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              upsellingItem.data.prices.default
                                                .price.formatted
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "add-to-basket mt-auto",
                                          attrs: { disabled: _vm.isLoading },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addToBasket(
                                                upsellingItem.data.variation.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-cart-plus",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "upselling-swiper-next",
                      staticClass: "swiper-button-next",
                    },
                    [_c("i", { staticClass: "fa fa-chevron-right" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "upselling-swiper-prev",
                      staticClass: "swiper-button-prev",
                    },
                    [_c("i", { staticClass: "fa fa-chevron-left" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  ref: "upselling-swiper-pagination",
                  staticClass: "swiper-pagination",
                }),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-2" }, [_c("b", [_vm._v("Passend dazu")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }